import React from 'react';
import Link from "next/link";
import process from "next/dist/build/webpack/loaders/resolve-url-loader/lib/postcss";
import MainButton from "./buttons/MainButton";

const PromoBanner = () => {
    return (
        <div className={'promo_banner'}>
            <div className="container">
                <div className="promo_banner_content">
                    <p>EARN INSTANT 20% BONUS USING PROMO CODE <span className={'promo_code'}>Pepe_Powell20</span></p>
                    <Link
                        className='nav_buy_button'
                        prefetch={false}
                        href={process.env.NEXT_PUBLIC_APP_URL}
                    >
                        BUY $PEPD NOW
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PromoBanner;